import Vue from 'vue'

// TODO サービスにする
const URL_BASE = process.env.VUE_APP_HELP_URL_BASE || '/help'

Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.help) this.$help = options.help
    else if (options.parent && options.parent.$help)
      this.$help = options.parent.$help
  },
})

export default {
  getHelpContent(id) {
    return fetch(`${URL_BASE}/${id}.md`).then(res => res.text())
  },
}
